import { CuboidCollider } from '@react-three/rapier';
import { useGame } from './score-context';

interface EndZoneProps {
  position: [number, number, number];
  size: [number, number, number];
}

export function EndZone({ position, size }: EndZoneProps) {
  const { balls, setBalls, isDropped, setIsDropped } = useGame();

  return (
    <CuboidCollider
      position={position}
      args={size}
      sensor
      onIntersectionEnter={(payload) => {
        if (payload.colliderObject?.name !== 'ball') {
          return;
        }
        if (payload.colliderObject.userData.isDead) {
          return;
        }
        // Mark this ball as already counted so we don't double-count it
        payload.colliderObject.userData.isDead = true;
        setBalls(balls - 1);
        setIsDropped(false);
      }}
    />
  );
}
